<style>
.modal-create-task {
  overflow-y: auto !important;
}

.modal-create-task {
  width: 90vw;
  height: 90vh !important;
}



.p-select {
  width: 100%;
}

.p-textarea {
  background: #fff;
  width: 100% !important;
}

.p-editor .p-editor-content.ql-disabled .ql-editor {
  background: var(--p-select-disabled-background)
}

label {
  font-size: var(--p-floatlabel-active-font-size);
  font-weight: var(--p-floatlabel-label-active-font-weight);
}


.p-message-error {
  color: #dc2626;
  font-size: 14px;
}

.p-message-content {
  height: fit-content !important;
}

.col-bottoni {
  display: flex;
  grid-column-gap: 20px;
  justify-content: end;
}

.close {
  text-align: right;
  margin-bottom: 20px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}

.card-body {
  position: relative;
  padding: 20px;
}
.titolo-modal{
  margin-bottom: 20px;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position modal-create-task">
    <div class="card mb-4">
      <div class="card-body p-3">
        <div class="close" @click="annulla()">
          <i class="pi pi-times" style="font-size: 20px"></i>
        </div>
        <h4 class="titolo-modal">{{ titolo }}</h4>
        <CustomForm
            v-slot="$form"
            :resolver="resolver"
            @submit="onFormSubmit"
            style="margin-top: 20px;"
        >
          <div class="row">
            <div class="col-12 mb-3">
              <label for="messaggio" class="form-label">Messaggio</label>
              <CustomTextArea
                  name="messaggio"
                  id="messaggio"
                  rows="5"
                  cols="10"
                  class="form-control"
              />
              <Message
                  v-if="$form.messaggio?.invalid"
                  severity="error"
                  variant="simple"
                  size="small"
              >
                Inserire un messaggio per la chiusura del Task Sprint
              </Message>
            </div>

            <div v-if="false" class="col-12 mb-3">
              <label for="timbratura" class="form-label">Timbratura (hh:mm)</label>
              <CustomTextInput
                  name="timbratura"
                  id="timbratura"
                  class="form-control"
                  placeholder="es. 08:30"
              />
              <Message
                  v-if="$form.timbratura?.invalid"
                  severity="error"
                  variant="simple"
                  size="small"
              >
                Inserire una timbratura valida nel formato hh:mm
              </Message>
            </div>

            <div class="col-12 mt-3">
              <CustomButton
                  type="submit"
                  severity="primary"
                  label="Conferma"
              />
              <CustomButton
                  @click="annulla()"
                  severity="secondary"
                  label="Annulla"
                  class="ms-2"
              />
            </div>
          </div>
        </CustomForm>
      </div>
    </div>
  </div>
</template>
<script>
import CustomButton from 'primevue/button';
import Message from 'primevue/message';
import CustomTextArea from 'primevue/textarea';
import CustomTextInput from 'primevue/inputtext';

import { Form as CustomForm } from '@primevue/forms';
import * as $ from 'jquery';
import { ref } from 'vue';
export default {
  name: "KModalGestioneNotifica",
  components: { CustomForm, Message, CustomTextArea, CustomButton,CustomTextInput },
  data() {
    return {
      status: '',
      notifica: null,
      $form: ref(),
      show: false,
      approvata: false,
      titolo: '',
      initialValues: ref({

      })
    }
  },
  setup() {
    return {
    }
  },
  mounted() {

  },
  created() {
    // $(document).keyup(function (e) {
    //   if (e.key === "Escape" && this.show) {
    //     this.annulla();
    //   }
    // }.bind(this));

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'startGestioneNotifica') {
        let payload = mutation.payload
        this.notifica = { ...payload.notifica };
        this.approvata = payload.approvata;
        this.titolo = payload.titolo;
        this.show = true;
      }

    });
  },
  methods: {
    resolver: ({ values }) => {
      const errors = {};
      // if (!values.messaggio) {
      //   errors.messaggio = [{ message: 'Inserire un messaggio.' }];
      // }
      return {
        errors
      };
    },
    onFormSubmit({ values, states, valid, errors }) {
      if (valid) {
        let messaggio=states.messaggio.value;
        if(!messaggio&& !this.approvata){
          messaggio='Rifiutato'
        }
        if(!messaggio && this.approvata){
          messaggio='Approvato'
        }
     //   console.log("messaggio=",messaggio,"timbratura=",states.timbratura.value);

        this.$store.dispatch('salvaNotifica',{
          approvata:this.approvata,
          notifica:{...this.notifica},
          messaggio:messaggio
         // timbratura:states.timbratura.value
        })


        this.show = false;
      }
    },
    annulla() {
      this.notifica = null;
      this.show = false;
      // let tasks = this.$store.getters.getAllTasks();
      // this.$store.dispatch("tasksLoaded", tasks);
      // $('html').css('overflow', 'auto')
    },
  }
}
</script>